import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { baseUrl, myBranchGateway, baseAPI } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
providedIn: 'root'
})

export class MyBranchService {
  private url = baseUrl + myBranchGateway;
  private apiUrl = baseAPI;
  private headers = { 'content-type': 'application/json'};

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getActiveBranches( ): Observable<string[]> {
    const url = `${this.url}`;
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'getActiveBranches' })
    .pipe(
      catchError(this.handleError('getActiveBranches', []))
    );
  }

  getSitesForBranch(code: string, date: any): Observable<any> {
    const url = `${this.url}`;
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'getSitesForBranch', item1: code, item2: date})
    .pipe(
      catchError(this.handleError('getSitesForBranch', []))
    );
  }

  getSitesData(code: string, date: any): Observable<any> {
    const url = `${this.url}`;
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'getSitesData', item1: code, item2: date})
    .pipe(
      catchError(this.handleError('getSitesData', []))
    );
  }

  getShiftsForSite(site: any, date: any): Observable<any> {
    const url = `${this.url}`;
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'getShiftsForSite', item1: site, item2: date})
    .pipe(
      catchError(this.handleError('getShiftsForSite', []))
    );
  }

  getSiteLeadData(): Observable<any> {
    const url = `${this.url}`;
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'getSiteLeadData'})
    .pipe(
      catchError(this.handleError('getSiteLeadData', []))
    );
  }

  getInsps(site: any, date: any): Observable<any> {
    const url = `${this.url}`;
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'getShiftsForSite', item1: site, item2: date})
    .pipe(
      catchError(this.handleError('getShiftsForSite', []))
    );
  }

  getInspsData(date: any): Observable<any> {
    const url = `${this.url}`;
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'getInspsData', item1: date})
    .pipe(
      catchError(this.handleError('getInspsData', []))
    );
  }

  getSupervisorsForSite(site: any): Observable<any> {
    const url = `${this.url}`;
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'getSupervisorsForSite', item1: site})
    .pipe(
      catchError(this.handleError('getSupervisorsForSite', []))
    );
  }

  getSites(): Observable<any> {
    const url = `${this.url}`;
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'getSites'})
    .pipe(
      catchError(this.handleError('getSites', []))
    );
  }

  getShiftsForSupervisor(inspectorId: number) {
    const url = `${this.url}`;
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'getShiftsForSupervisor', item1: inspectorId})
    .pipe(
      catchError(this.handleError('getShiftsForSupervisor', []))
    );
  }

  setShiftsForSupervisor(fullName: string, inspectorId: number, siteId: number, shiftsToAdd: string) {
    const url = `${this.url}`;
    // console.log('add', fullName, inspectorId, siteId, shiftsToAdd);
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'setShiftsForSupervisor',
      item1: fullName, item2: inspectorId, item3: siteId, item4: shiftsToAdd})
      .pipe(
        catchError(this.handleError('setShiftsForSupervisor'))
      );
  }

  removeShiftsForSupervisor(fullName: string, inspectorId: number, siteId: number, shiftsToRemove: string) {
    const url = `${this.url}`;
    // console.log('remove', fullName, inspectorId, siteId, shiftsToRemove);
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'removeShiftsForSupervisor',
      item1: fullName, item2: inspectorId, item3: siteId, item4: shiftsToRemove})
      .pipe(
        catchError(this.handleError('removeShiftsForSupervisor'))
      );
  }

  getSitesWithHandout(): Observable<any> {
    const body = {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal'
    };
    const url = `${this.apiUrl}/insync/sitesWithHandout`;
    return this.http.post(url, body, {'headers': this.headers})
    .pipe(
      catchError(this.handleError('getSitesWithHandout'))
    );
  }

  uploadSiteHandout(formData: any, siteID: number): Observable<any> {
    const url = `${this.apiUrl}/insync/uploadSiteHandout/${siteID}`;
    return this.http.post(url, formData)
    .pipe(
      catchError(this.handleError('uploadSiteHandout'))
    );
  }

  downloadSiteHandout(siteID: number, siteName: string): Observable<any>  {
    const body = {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal'
    };
    const url = `${this.apiUrl}/insync/downloadSiteHandout/${siteID}`;
    return this.http.post(url, body, {'headers': this.headers, responseType: 'blob'})
    .pipe(
      catchError(this.handleError('downloadSiteHandout'))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
